const resetPassInputs = [
  {
    label: 'New Password',
    name: 'new_password',
  },
];

export default resetPassInputs;
